<template>
  <PageSkeletonThee>
    <template slot="header-left">
      <p>
        <span>文件名称：</span>
        <span>{{ defaultTips(fileDetails.fileName) }}</span>
      </p>
    </template>

    <template slot="header-right">
      <el-button size="medium" round @click="downloadFile">下载</el-button>
    </template>

    <template slot="container">
      <el-table v-if="documentarys.length" ref="table" row-key="id" fit :data="documentarys" v-loading="loading" height="100%" :style="{ width: setTableWidth }">
        <el-table-column v-for="(item, index) in header" :key="index" :label="item.label" :fixed="item.isFixed && 'left'" :width="setTableWidth === '100%' ? null : item.width">
          <template #header>
            <div class="header-label">
              <span v-html="item.label" />
              <i class="fixed-nail iconfont icon-guding" :class="{ nail: item.isFlag }" @click="() => handleClickFlag(item)" />
            </div>
          </template>

          <template v-slot="{ row }">
            <el-popover v-if="validateURL(row[item.prop])" placement="right" trigger="hover">
              <img class="content-img" :src="row[item.prop]" alt="img.png" />
              <img slot="reference" class="goods-img" :src="row[item.prop]" alt="img.png" />
            </el-popover>
            <template v-else-if="item.label === 'Tracking Number'">
              <a :href="`https://www.dhl.com/hk-zh/home/tracking/tracking-express.html?submit=1&tracking-id=${row[item.prop]}`" target="_blank">{{ row[item.prop] }}</a>
            </template>
            <span v-else v-html="row[item.prop]" />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </PageSkeletonThee>
</template>

<script>
import API from '@/api'
import Papa from 'papaparse'
import { validateURL } from '@/utils/validate'
import PageSkeletonThee from '@/components/PageSkeletonThee.vue'

export default {
  components: {
    PageSkeletonThee
  },
  data() {
    return {
      validateURL,

      fileId: undefined, // 文件ID

      sectionOffsetWidth: 0, // 表格父元素的宽度

      header: [],
      fileDetails: {},
      documentarys: [],
      loading: false
    }
  },
  async created() {
    this.fileId = this.$route.query.id
    await this.getDocumentaryFileDetails(this.fileId)
    if (this.fileDetails.fileUrl) {
      this.getGenerateTabeData(this.fileDetails.fileUrl)
    } else {
      this.$message.warning('file url nothingness!')
    }
  },
  mounted() {
    let section = document.getElementById('page-skeleton-thee-section')
    if (section) {
      this.sectionOffsetWidth = section.offsetWidth
    }
  },
  computed: {
    /**
     * 动态设置表格的宽度
     */
    setTableWidth() {
      let width = this.header.reduce((previous, item) => {
        if (item) {
          previous += item.width
        }
        return previous
      }, 0)
      if (this.sectionOffsetWidth > width) {
        return '100%'
      } else {
        return `${width}px`
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  watch: {
    /**
     * 自动设置表格列的宽度
     *
     * @param data 表格数据源
     */
    documentarys(data) {
      this.header = this.header.map((value) => {
        let arr = data.map((item) => item[value.prop])
        arr.push(value.label)
        value.width = this.getMaxLength(arr) + 80
        return value
      })
    }
  },
  methods: {
    /**
     * API 获取跟单文件详情
     *
     * @param {String} fileId 文件ID
     */
    async getDocumentaryFileDetails(fileId) {
      try {
        this.loading = true
        let { data } = await API.getDocumentaryFileDetails(fileId)
        this.fileDetails = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 点击某个表头的小旗帜
     *
     * @param {Object} header
     */
    handleClickFlag(header) {
      let index = 0
      this.header.forEach((item, i) => {
        if (item.label === header.label) {
          index = i
        }
      })
      this.header.forEach((item, i) => {
        if (i <= index) {
          item.isFlag = true
          item.isFixed = true
        } else {
          item.isFlag = false
          item.isFixed = false
        }
      })
    },

    /**
     * 生成表格数据的方法
     *
     * @param {Boolean} fileUrl 文件路径
     */
    async getGenerateTabeData(fileUrl) {
      let data = await API.getDocumentaryFile(fileUrl)
      let reader = new FileReader()
      reader.readAsText(data, 'GB2312')
      reader.onload = (event) => {
        if (event.target && event.target.result) {
          let result = Papa.parse(event.target.result)
          if (result.data.length >= 2) {
            result.data.pop()
          }
          let header = result.data.shift()
          if (header && header.length) {
            this.header = header.map((item, index) => ({
              label: item.trim(),
              prop: item.trim(),
              width: null,
              isFixed: [0, 1, 2, 3].includes(index) ? true : false,
              isFlag: [0, 1, 2, 3].includes(index) ? true : false
            }))
          }
          let sum = 0
          if (result.data.length) {
            sum = result.data[0].length
            for (let i = 1; i <= result.data.length; i++) {
              if (result.data[i] && result.data[i].length > sum) {
                sum = result.data[i].length
              }
            }
          }
          let index = 1
          this.header.forEach((item) => {
            if (!item.label && !item.prop) {
              item.label = `unknown ${index}`
              item.prop = `unknown ${index}`
              index++
            }
          })
          if (sum > this.header.length) {
            let num = sum - this.header.length
            for (let i = 1; i <= num; i++) {
              this.header.push({
                label: `unknown ${index}`,
                prop: `unknown ${index}`,
                width: null,
                isFixed: [0, 1, 2, 3].includes(index) ? true : false,
                isFlag: [0, 1, 2, 3].includes(index) ? true : false
              })
              index++
            }
          }
          result.data.forEach((item) => {
            let temporary = {}
            item.forEach((field, index) => {
              temporary[this.header[index].label] = field
            })
            this.documentarys.push({ ...temporary })
          })
        }
      }
    },

    /**
     * 遍历列的所有内容
     * 获取最宽一列的宽度
     *
     * @param arr 所有列的数据
     */
    getMaxLength(arr) {
      return arr.reduce((previous, item) => {
        if (item) {
          let calcLen = this.getTextWidth(item)
          if (previous < calcLen) {
            previous = calcLen
          }
        }
        return previous
      }, 0)
    },

    /**
     * 使用span标签包裹内容
     * 然后计算span的宽度
     *
     * @param str 列的内容
     */
    getTextWidth(str) {
      if (this.validateURL(str)) {
        return 68
      } else {
        let width = 0
        let element = document.createElement('span')
        element.innerText = str
        element.className = 'getTextWidth'
        document.querySelector('body').appendChild(element)
        width = document.querySelector('.getTextWidth').offsetWidth
        document.querySelector('.getTextWidth').remove()
        return width
      }
    },

    /**
     * 下载文件
     */
    downloadFile() {
      if (this.fileDetails.fileUrl) {
        window.open(this.fileDetails.fileUrl)
      } else {
        this.$message.warning('file url nothingness!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  color: #10141d;
  font-size: 14px;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.02);
}

.header-label {
  width: 100%;
  display: inline-block;
  &:hover {
    .fixed-nail {
      display: inline-block;
    }
  }
  .fixed-nail {
    display: none;
    color: #99c41c;
    margin-left: 2px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
    &.nail {
      color: #f56c6c;
      display: inline-block;
    }
  }
}

.content-img,
.goods-img {
  border-radius: 4px;
  object-fit: cover;
}

.content-img {
  width: 228px;
  height: 228px;
}

.goods-img {
  width: 68px;
  height: 68px;
  cursor: pointer;
}

a:link,
a:visited,
a:hover,
a:active {
  color: #99c41c;
  text-decoration: none;
}
</style>
